export const SET_CURR_WRITING_OFFLINE = 'SET_CURR_WRITING_OFFLINE';
export const UNSET_CURR_WRITING_OFFLINE = 'UNSET_CURR_WRITING_OFFLINE';
